import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table";
import Pagination from "component/common/Pagination";
import Loader from "component/common/Loader";
import styles from "./styles.module.scss";
import moment from "moment";
import { getDisputeHistory } from "service/Disputed";
import arrow from "assets/images/arrow.svg";

const DisputeHistory = () => {
  let location = useLocation();
  const history = useHistory();

  const historyHeader = [
    "Seller ID",
    "Buyer ID",
    "UPI ID/Bank Account",
    "Total Amount",
    "Sale Date",
    "Payment Date",
    "Payment Status",
  ];

  const [disputeHistoryData, setPaymentHistoryData] = useState();

  let [totalPages, setTotalPages] = useState(0);
  const [pageMeta, setPageMeta] = useState({
    page: 1,
    limit: 10,
    totalPages: 0,
  });

  const getDisputeHistoryFunc = async (page, limit) => {
    let params = {
      page: page != null ? page : 1,
      limit: limit,
    };
    try {
      let response = await getDisputeHistory(params);
      if (response.status == 200) {
        let initialVal = response.data.data;
        setPaymentHistoryData(initialVal);
        let data = { ...pageMeta };
        data.totalPages = response.data.data.pageMeta.totalPages;
        data.page = response.data.data.pageMeta.page;
        setPageMeta(data);
        setTotalPages(data.totalPages);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (res) => {
    getDisputeHistoryFunc(res, pageMeta.limit);
  };

  useEffect(() => {
    getDisputeHistoryFunc(pageMeta.page, pageMeta.limit);
  }, [location.search]);

  if (disputeHistoryData == null) return <Loader />;

  return (
    <>
      <div className="row mb-4">
        <div className="col-md-6">
          <div className={styles.donation_title}>
            <img
              src={arrow}
              className="back-arrow"
              onClick={() => history.goBack()}
              alt="arrow"
            />
            <b className="mx-2">Dispute History</b>
          </div>
        </div>
      </div>
      <Table>
        <TableHead className={styles.donation_head} head={historyHeader} />
        <TableBody>
          {disputeHistoryData?.data?.length > 0 ? (
            disputeHistoryData.data.map((list, index) => {
              return (
                <tr
                  key={index}
                  className={styles.donation_body}
                  style={{ verticalAlign: "center" }}
                >
                  <td>
                    {list.sellerId_by_user ? list.sellerId_by_user : "----"}
                  </td>
                  <td>{list.buyerId}</td>
                  <td>{list.upiId}</td>
                  <td>{list.amount ? list.amount : "---"}</td>
                  <td>
                    {list?.sale_date
                      ? moment(list.sale_date).format("DD/MM/YYYY")
                      : "----"}
                  </td>
                  <td>{list.paymentDate}</td>
                  <td className="text-capitalize">{list.paymentStatus}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={pageMeta.page != null ? pageMeta.page : 1}
          onPageChange={(res) => handlePageChange(res)}
        />
      )}
    </>
  );
};

export default DisputeHistory;
